package fr.frux.shared.data.local

import dev.zacsweers.metro.ContributesTo
import dev.zacsweers.metro.Provider
import dev.zacsweers.metro.Provides
import dev.zacsweers.metro.SingleIn
import fr.frux.core.common.di.AppScope
import fr.frux.core.database.FruxDatabase
import fr.frux.core.database.localDatabaseSupported
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

/**
 * Fourniture du cache local des lieux. Comme pour les arbres, la base arrive en [Provider] et
 * n'est déréférencée que si la cible a un driver SQLite : sur web le graphe retombe sur
 * [NoOpSiteLocalDataSource].
 */
@ContributesTo(AppScope::class)
interface SiteLocalDataSourceModule {
    companion object {
        @OptIn(ExperimentalTime::class)
        @Provides
        @SingleIn(AppScope::class)
        fun provideSiteLocalDataSource(
            database: Provider<FruxDatabase>,
            policy: TreeCachePolicy,
        ): SiteLocalDataSource =
            if (localDatabaseSupported) {
                SqlDelightSiteLocalDataSource(database(), policy) { Clock.System.now().toEpochMilliseconds() }
            } else {
                NoOpSiteLocalDataSource
            }
    }
}
